var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSubdomainOverlay
    ? _c("domain-not-found-overlay")
    : !_vm.isSupportedBrowser
    ? _c("browser-not-supported-overlay")
    : _c(
        "fragment",
        [
          !_vm.isRecommendedBrowser
            ? _c("browser-not-recommended-overlay")
            : _vm._e(),
          _vm._v(" "),
          _c("router-view"),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }